
const state = {
  booking_confirmation_id: '',
  layout_template_id: undefined,
  notes: '',
  page_options: [],
  page_position: '',
  preflight_notes: '',
  preflight_status_id: undefined,
  publication_edition_id: undefined,
  publication_id: undefined,
  publication_product_id: undefined,
}

export const requiredFields = [
  { key: 'layout_template_id' },
  { key: 'publication_edition_id' },
  { key: 'publication_id' },
  { key: 'publication_product_id' },
]

export default state
